
<template>

<div>
    
    <div class="metrics-container" v-if="enrollments || orphaned.length">                
        <div v-for="enrollment in enrollments" :key="enrollment.id">
        
            <h4>Marks for {{getProgramName(enrollment.programId)}} {{enrollment.intake | intakeDate}}</h4>
        
             <div v-for="metric in enrollment.marks" v-if="metric.term.type !== 'mentorship'" class="term-metrics">
                <div @click="toggleTerm(metric.term.id)" class="term-header">
                    <i v-if="selectedTerms.includes(metric.term.id)" class="fa fa-caret-down"></i>
                    <i v-else class="fa fa-caret-right"></i>
                    {{metric.term.name}}
                    <span class="total-mark" v-if="new Date(metric.term.endDate) < new Date()">
                        {{metric.totalMark}}%&nbsp;&nbsp;{{letterGrade(metric.totalMark)}}
                    </span>
                </div>
                <div v-show="selectedTerms.includes(metric.term.id)" class="metrics">
                    <div>
                        <span class="bold" v-if="usesNewMarkingSystem(metric)">10% Live Session Attendance</span>
                        <span class="bold" v-else>25% Metrics</span>

                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">10% Video Progress: <span class="mark">{{metric.video.mark}}% {{metric.video.progress}} / {{metric.video.totalDuration}}</span></div>
                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">5% Forum / Chat: <span class="mark">{{metric.interactions.mark}}%</span></div>
                        <div class="indent clearfix">Attendance: <span class="mark">{{metric.meetings.attended}} / {{metric.meetings.total}}</span></div>
                    </div>
                    <div class="clearfix">
                        <span @click="toggleAssignments(metric.term.id)">

                            <span class="bold" v-if="usesNewMarkingSystem(metric)">40% Assignments:</span>
                            <span class="bold" v-else>25% Assignments:</span>
                            <i v-if="selectedAssignments.includes(metric.term.id)" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </span>
                        <span class="mark">{{metric.assignments.mark}}%</span>
                        <div class="submissions" v-show="selectedAssignments.includes(metric.term.id)">
                            <div v-for="assignment in metric.assignments.assignments">                                                
                                Week {{assignment.week}}:
                                <span v-if="assignment.instance['associated.name']">{{assignment.instance['associated.name']}}</span>
                                &ndash; {{assignment.name}}
                                <span class="mark" v-if="assignment.submission">                                                    
                                    <span v-if="assignment.submission.grade == null">Ungraded</span>
                                    <span v-else>{{assignment.submission.grade}}</span>
                                    <span v-if="assignment.submission.grade != null">%</span>
                                </span>
                                <span v-else class="mark">Incomplete</span>
                                <span class="mark" v-else="Not Submitted"></span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix">
                        <span class="bold">50% Final Project:</span> 
                        <span v-if="metric.finalProject && new Date(metric.term.endDate) < new Date()" class="mark">
                            <span v-if="metric.finalProject.submission && isNaN(metric.finalProject.mark)">Ungraded</span>
                            <span v-if="!metric.finalProject.submission">Incomplete</span>
                            <span v-if="metric.finalProject.submission && metric.finalProject.mark">
                                {{metric.finalProject.mark}}%
                            </span>
                        </span>
                    </div>
                        
                </div> 
            </div>
        </div>

        <h4>Marks for Un-Enrolled Terms</h4>
            <div v-for="metric in orphaned" v-if="metric.term.type !== 'mentorship'" class="term-metrics">
                <div @click="toggleTerm(metric.term.id)" class="term-header">
                    <i v-if="selectedTerms.includes(metric.term.id)" class="fa fa-caret-down"></i>
                    <i v-else class="fa fa-caret-right"></i>
                    {{metric.term.name}}
                    <span class="total-mark" v-if="new Date(metric.term.endDate) < new Date()">
                        {{metric.totalMark}}%&nbsp;&nbsp;{{letterGrade(metric.totalMark)}}
                    </span>
                </div>
                <div v-show="selectedTerms.includes(metric.term.id)" class="metrics">
                    <div>
                        <span class="bold" v-if="usesNewMarkingSystem(metric)">10% Live Session Attendance</span>
                        <span class="bold" v-else>25% Metrics</span>

                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">10% Video Progress: <span class="mark">{{metric.video.mark}}% {{metric.video.progress}} / {{metric.video.totalDuration}}</span></div>
                        <div v-if="!usesNewMarkingSystem(metric)" class="indent clearfix">5% Forum / Chat: <span class="mark">{{metric.interactions.mark}}%</span></div>
                        <div class="indent clearfix">Attendance: <span class="mark">{{metric.meetings.attended}} / {{metric.meetings.total}}</span></div>
                    </div>
                    <div class="clearfix">
                        <span @click="toggleAssignments(metric.term.id)">

                            <span class="bold" v-if="usesNewMarkingSystem(metric)">40% Assignments:</span>
                            <span class="bold" v-else>25% Assignments:</span>
                            <i v-if="selectedAssignments.includes(metric.term.id)" class="fa fa-caret-down"></i>
                            <i v-else class="fa fa-caret-right"></i>
                        </span>
                        <span class="mark">{{metric.assignments.mark}}%</span>
                        <div class="submissions" v-show="selectedAssignments.includes(metric.term.id)">
                            <div v-for="assignment in metric.assignments.assignments">                                                
                                Week {{assignment.week}}:
                                <span v-if="assignment.instance['associated.name']">{{assignment.instance['associated.name']}}</span>
                                &ndash; {{assignment.name}}
                                <span class="mark" v-if="assignment.submission">                                                    
                                    <span v-if="assignment.submission.grade == null">Ungraded</span>
                                    <span v-else>{{assignment.submission.grade}}</span>
                                    <span v-if="assignment.submission.grade != null">%</span>
                                </span>
                                <span v-else class="mark">Incomplete</span>
                                <span class="mark" v-else="Not Submitted"></span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix">
                        <span class="bold">50% Final Project:</span> 
                        <span v-if="metric.finalProject && new Date(metric.term.endDate) < new Date()" class="mark">                            
                            <span v-if="metric.finalProject.submission && isNaN(metric.finalProject.mark)">Ungraded</span>
                            <span v-if="!metric.finalProject.submission">Incomplete</span>
                            <span v-if="metric.finalProject.submission && metric.finalProject.mark">
                                {{metric.finalProject.mark}}%
                            </span>
                        </span>
                    </div>
                        
                </div> 
            </div>

    </div>

</div>

</template>

<script>

import users from '../../services/users';
import courses from '../../services/courses';

export default {
    props: ['userId','currentTerm'],
    data() {
        return {
            metrics: null,
            selectedTerms: [],
            selectedAssignments: [],
            enrollments: null,
            orphaned: [],
            programs: []

        }
    },
    components: {

    },
    created() {

    },
    mounted() {
        this.getUser();
        courses.getPrograms().then((response)=>{
            this.programs = response.data.programs;
        });
    },
    methods: {
        getProgramName(id) {
            const program = this.programs.find(p => p.id === id)
            if (program) {
                return program.name;
            } 
            return 'Unknown';
        },
        toggleTerm(id) {
            let index = this.selectedTerms.indexOf(id);
            index > -1 ? this.selectedTerms.splice(index, 1) : this.selectedTerms.push(id);
        },
        toggleAssignments(id) {
            let index = this.selectedAssignments.indexOf(id);
            index > -1 ? this.selectedAssignments.splice(index, 1) : this.selectedAssignments.push(id);
        },
        getUser() {
            return users.getMe(this, this.userId).then((response) => {
                const student = response.data.person;

                let enrollments;
                if (this.$route.query.final_project  && this.$route.query.final_project == 'true') {                     
                    enrollments = student.enrollments
                        .filter((e)=>{                    
                            return e.termIds.includes(this.currentTerm.id)
                        })
                        .map((e) => {
                            return {...e, marks: []}
                        });
                } else {
                    enrollments = student.enrollments
                    
                    .map((e) => {
                        return {...e, marks: []}
                    });
                }

                const orphaned = [];

                this.extraEnrollmentLetters = student.upsells;
                
                if (student.letters) {
                    this.enrollmentLetters = student.letters.filter(l => l.type === 'enrollment_letter');
                }                                                

                if (student.student_statuses.length === 0) { // this is a demo user that was not set up right
                    student.student_statuses = [{status: 'unknown'}]
                }

                this.status = student.student_statuses[0].status;                
                this.pastStatuses = student.student_statuses;
                

                if (student.marks && student.marks.length > 0) {

                    for (const mark of student.marks) {
                        const enrollment = enrollments.findIndex(e => e.termIds.includes(mark.marks.term.id));
                        if (enrollment > -1) {
                         enrollments[enrollment].marks.push(mark);
                        } else {
                            orphaned.push(mark.marks);
                        }
                    }                   

                    for (const enrollment of enrollments) {
                        enrollment.marks = enrollment.marks                        
                            .sort((a, b) => { return new Date(a.marks.term.startDate) - new Date(b.marks.term.startDate) })
                            .map((m) => {
                                if (m.mark_overrides && m.mark_overrides.length > 0) {
                                    let overrides = m.mark_overrides.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
                                    m.marks = overrides[0].marks;
                                    m.overridden = true;
                                }
                                return m.marks;
                            });
                    }                    
                }
                this.enrollments = enrollments;
                this.orphaned = orphaned;
                return true;
            });
        },
        usesNewMarkingSystem(mark) {
            return !mark.video;
        },
        letterGrade(mark) {
            if (mark >= 97) return 'A+';
            if (mark >= 93) return 'A';
            if (mark >= 90) return 'A-';
            if (mark >= 87) return 'B+';
            if (mark >= 83) return 'B';
            if (mark >= 80) return 'B-';
            if (mark >= 77) return 'C+';
            if (mark >= 73) return 'C';
            if (mark >= 70) return 'C-';
            if (mark >= 67) return 'D+';
            if (mark >= 63) return 'D';
            if (mark >= 60) return 'D-';
            if (mark < 60) return 'F';
            return 'Incomplete';

        },
    },
    computed: {

    }
}
</script>

<style lang="scss" scoped>
    .mark {
        background: initial;
    }
.metrics-container {

    //        border:1px solid #b0b0b0;
    .term-metrics:last-child .term-header {

        border-bottom: 1px solid #b0b0b0;
    }

    i {
        cursor: pointer;
    }
}

.term-metrics {
    .term-header {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        border-bottom: none;
        cursor: pointer;
        font-size: 1.2em;
        font-weight: bold;

        .total-mark {
            float: right;
        }
    }

    .metrics {
        padding: 1rem;
        border: 1px solid #b0b0b0;
    }

    .submissions {
        border: 1px solid #b0b0b0;
        padding: 1rem;
        margin: 1rem -1rem;

        &>div {
            border-bottom: 1px solid #b0b0b0;
            padding: .5rem 0;
        }

        &>div:last-child {
            border-bottom: none;
        }
    }
}


</style>


// WEBPACK FOOTER //
// StudentAdminStatus.vue?52f54518